export default "__VITE_ASSET__Cjm_QiVP__"